// IMPORTANT: Replace 'YOUR_API_ID' with your actual SheetDB API ID.
// You only need ONE sheet (the first/default tab). Each order is added as a new row.
// Columns (row 1 headers, exact names):
//   order_number | created_at | pickup_date | customer_name | phone | notes | items | item_count | total | status
// You manage orders by editing the "status" column (e.g. "Not done" -> "Done").
// Until you paste your real API URL, the app falls back to the built-in menu
// and orders are not sent to the sheet (so the preview keeps working).
export const SHEETDB_API_URL = 'https://sheetdb.io/api/v1/urfhy2ix8qzi2'

export const isSheetDbConfigured = (): boolean =>
  !SHEETDB_API_URL.includes('YOUR_API_ID')

// Single sheet — orders are posted to the base API URL.
export const getOrdersUrl = () => SHEETDB_API_URL
